import Vue from 'vue'
import $store from '@/store/store'
import { EventBus, EventBusType } from '@/event-bus'
import { actionTypes } from '@/store/actionTypes'
import $filters from '@/modules/fptai/filters/filters'

const AppService = {
    promise: {
        SELECT_PROJECT: null,
        CONFIRM: null,
        CREATE_API_KEY: null
    },
    loading (show = true) {
        $store.dispatch(actionTypes.LOADING, show)
    },
    showLoading () {
        $store.dispatch(actionTypes.LOADING, true)
    },
    hideLoading () {
        $store.dispatch(actionTypes.LOADING, false)
    },
    inform (message, options) {
        EventBus.$emit(EventBusType.INFORM, { message, options })
    },
    closeInform () {
        EventBus.$emit(EventBusType.CLOSE_INFORM)
    },
    toast (message, type) {
        EventBus.$emit(EventBusType.TOAST, {
            group: 'app',
            title: '',
            text: message,
            duration: 3000,
            type: type
        })
    },
    toastSuccess (message) {
        this.toast(message, 'success')
    },
    toastError (message) {
        this.toast(message, 'error')
    },
    toastInfo (message) {
        this.toast(message, 'info')
    },
    createProject (nextAction = '', apiId = '') {
        EventBus.$emit(EventBusType.CREATE_PROJECT, { nextAction, apiId })
    },
    selectProject () {
        EventBus.$emit(EventBusType.SELECT_PROJECT)
        return new Promise((resolve, reject) => {
            this.promise.SELECT_PROJECT = { resolve, reject }
        })
    },
    confirm (message) {
        EventBus.$emit(EventBusType.CONFIRM, message)
        return new Promise((resolve, reject) => {
            this.promise.CONFIRM = { resolve, reject }
        })
    },
    createApiKey () {
        EventBus.$emit(EventBusType.CREATE_API_KEY)
        return new Promise((resolve, reject) => {
            this.promise.CREATE_API_KEY = { resolve, reject }
        })
    },
    handleRequestError (alternateErrorMessage, hideLoading = false) {
        return error => {
            if (hideLoading) {
                this.hideLoading()
            }
            if (error.response && error.response.data) {
                let data = error.response.data
                let errorMessage = ''
                if (Array.isArray(data)) {
                    errorMessage = data.join('')
                } else if (typeof data === 'object') {
                    if (data.message) {
                        errorMessage = data.message
                    }
                }
                this.toastError(errorMessage)
            } else if (alternateErrorMessage) {
                this.toastError(alternateErrorMessage)
            } else {
                this.toastError(this.$t('error'))
            }
        }
    },
    mapPagination (pagination) {
        let str = 'page=' + pagination.page
        str += '&page_size=' + pagination.rowsPerPage
        if (pagination.sortBy) {
            let orderDirection = pagination.descending ? '-' : ''
            str += '&ordering=' + orderDirection + pagination.sortBy
        }
        return str
    },
    correctHeaders (headers, sortable) {
        for (let header of headers) {
            header.text = $filters.capitalize(header.text)
            header.sortable = sortable || header.sortable || false
            header.visible = typeof header.visible === 'boolean' ? header.visible : true
        }
        return headers.filter(item => item.visible)
    },
    getLocale () {
        return window.vueapp.$i18n.locale.split('-')[0]
    }
}

for (let i in AppService.promise) {
    EventBus.$on(EventBusType[i + '_DONE'], data => {
        if (AppService.promise[i]) {
            AppService.promise[i].resolve(data)
        }
    })
}

Vue.prototype.$appService = AppService

export default AppService
